/**
 * Rows grouped by the machine they belong to — for More, where Artifacts and Backups
 * are each one collapsible group per machine, the way the Agents rail is.
 *
 *   owner, 2026-09-29: 把不同機器上面的 artifact 分類起來 … 像在使用 Agents 這個 side
 *   panel 裡面可以讓它打開收起來的方式 … Backup 也可以使用同樣的方式, 依照機器分類.
 *
 * Machines A→Z by the name each one SHOWS — the rail's own order (Sidebar.tsx), so a
 * machine sits in the same place in every list. Rows keep the order they came in.
 */
export type MachineGroup<T> = { deviceId: string; name: string; rows: T[] }

export function groupByMachine<T>(
  rows: readonly T[],
  deviceOf: (r: T) => string,
  nameOf: (r: T) => string,
): MachineGroup<T>[] {
  const by = new Map<string, MachineGroup<T>>()
  for (const r of rows) {
    const id = deviceOf(r)
    const g = by.get(id)
    if (g) g.rows.push(r)
    else by.set(id, { deviceId: id, name: nameOf(r) || 'A machine', rows: [r] })
  }
  return [...by.values()].sort(
    (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }) || a.deviceId.localeCompare(b.deviceId),
  )
}
